module.exports = require("path");


//////////////////
// WEBPACK FOOTER
// external "path"
// module id = 14
// module chunks = 0